import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import useAdminApi from '../../service/adminService';
import ActivityHistory from './ActivityHistory';
import OrderEmails from './OrderEmails';
import OrderInvoice from './OrderInvoice';
import OrderPayment from './OrderPayment';
import OrderSummary from './OrderSummary';

export default function OrderDetails() {
    const { orderId } = useParams();
    return <OrderRecord key={orderId} orderId={orderId} />;
}

function OrderRecord({ orderId }) {
    const location = useLocation();
    const api = useAdminApi();
    const [order, setOrder] = useState(null);
    const [busy, setBusy] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [message, setMessage] = useState(location.state?.notice || '');

    useEffect(() => {
        let active = true;
        setError('');
        setMessage(location.state?.notice || '');
        setOrder(null);
        setLoading(true);
        api(`/orders/${orderId}`)
            .then((data) => {
                if (active) setOrder(data);
            })
            .catch((requestError) => {
                if (active) setError(requestError.message);
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, [api, location.state, orderId]);

    const run = async (action, { reportError = true } = {}) => {
        let requestFailure = null;
        setBusy(true);
        setError('');
        setMessage('');
        try {
            await action();
        } catch (requestError) {
            requestFailure = requestError;
            if (reportError) setError(requestError.message);
        } finally {
            setBusy(false);
        }
        return requestFailure;
    };

    if (loading) return <p role="status">Loading order…</p>;
    if (!order) return <p role="alert">{error || 'Order unavailable.'}</p>;

    return (
        <div>
            {error && (
                <p
                    className="po-error"
                    role="alert">
                    {error}
                </p>
            )}
            {message && (
                <p
                    className="po-notice"
                    role="status">
                    {message}
                </p>
            )}
            <div className="po-heading">
                <h2>{`PO ${order.poNumber}`}</h2>
            </div>
            <div className="po-panel">
                <OrderSummary order={order} />
                <OrderInvoice
                    api={api}
                    busy={busy}
                    invoiceNumber={order.invoiceNumber}
                    orderId={orderId}
                    run={run} />
            </div>
            <OrderEmails
                api={api}
                applyOrder={setOrder}
                busy={busy}
                order={order}
                orderId={orderId}
                run={run}
                setMessage={setMessage} />
            <OrderPayment
                api={api}
                applyOrder={setOrder}
                busy={busy}
                order={order}
                orderId={orderId}
                run={run}
                setMessage={setMessage} />
            <ActivityHistory audit={order.audit} />
        </div>
    );
}
